import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBizlyDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 65,
	height: 33,
	viewBox: "0 0 65 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M21.4134 0.332794C22.8982 0.266232 24.152 1.43107 24.218 2.962V2.99528C24.185 4.52621 22.9312 5.72433 21.4464 5.69105C21.4464 5.69105 21.4464 5.69105 21.4134 5.69105C19.8957 5.72433 18.6419 4.52621 18.6089 2.99528C18.6749 1.46435 19.9287 0.299513 21.4134 0.332794Z",
			fill: "#AB37B8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.50251 24.7278C8.54566 24.7278 7.5888 24.5281 6.73094 24.1953C5.80708 23.8625 5.01521 23.2301 4.4543 22.4647V24.4282H0V0.0332031H4.4213V10.4502C5.01521 9.65144 5.80709 9.05237 6.69795 8.71956C9.50251 7.588 12.736 8.25363 14.8807 10.4169C16.4314 12.0477 17.2893 14.2109 17.2233 16.4741C17.2893 18.7372 16.4314 20.9337 14.8807 22.5312C13.4619 23.929 11.5152 24.7278 9.50251 24.7278ZM8.64464 12.3472C6.40099 12.3472 4.55328 14.1777 4.55328 16.4408C4.55328 18.7039 6.368 20.5676 8.61165 20.5676C10.8553 20.5676 12.703 18.7372 12.703 16.4741V16.4408C12.736 14.2109 10.9543 12.3805 8.74362 12.3472C8.71063 12.3472 8.67763 12.3472 8.64464 12.3472Z",
			fill: "#121314"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.2354 24.3946H23.6567V8.51953H19.2354V24.3946Z",
			fill: "#121314"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.0886 11.9142L32.2029 20.2345H40.0886V24.3946H25.9009V21.0332L33.6217 12.6797H26.3958V8.51953H40.1216L40.0886 11.9142Z",
			fill: "#121314"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42.5308 24.3951H46.9521V0H42.5308V24.3951Z",
			fill: "#121314"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.9999 8.51953L55.2664 32.2157H50.5481L54.2765 22.897L48.0405 8.51953H52.9238L56.6522 17.7051L60.2816 8.51953H64.9999Z",
			fill: "#121314"
		})
	]
});
export default SvgBizlyDark;
